import { Box, Drawer, Grid, Tab, Tabs } from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "../../Store";
import { strings } from "../../Store/Localization";
import Loader from "../../UiComponent/Loader";
import NewHeader from "../../UiComponent/NewHeader";
import noChatimage from "../../assets/images/FrankIcons/noChatimage.png";
import noImage from "../../assets/images/FrankIcons/noImageAvailable.png";
import apiServices from "../../services/RequestHandler";
import { getDataFromLocalStorage } from "../../utils/LocalStore.util";
import { color_theme, defaultLabelColors } from "../../utils/constants";
import {
  currencyFormat,
  handleLocalize,
  numberFormatWithoutCurrencyFixed,
} from "../../utils/helper";
import {
  firestoreDB,
} from "../../utils/notificationListner";

import { collection, onSnapshot, query, where } from "firebase/firestore";
import AnnouncementChat from "./AnnouncementChat";
import MarketPlaceChat from "./MarketPlaceChat";
import InputField from "../../UiComponent/TextFeild";
import {
  BackIconHalf,
  SearchIconforAnnounces,
} from "../../assets/images/FrankIcons";
import DrawerAnnounceDetail from "../MesActivity/DrawerAnnounceDetail";
import DrawerJobDetail from "../MesActivity/DrawerJobDetail";
import _ from "lodash";
import { useMediaQuery, useTheme } from "@mui/system";
import MobileResponsive from "../LandingPage/MobileResponsive";
const useStyles = makeStyles(() => ({
  scrollableArea: {
    height: "600px",
    // width: "100%",
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: color_theme.sand,
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      // backgroundColor: "#f5f5f5",
    },

    scrollbarWidth: "thin",
    scrollbarColor: `${color_theme.sand} #f5f5f5`,
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0, gap: 10, marginTop: "24px" }}>{children}</Box>
      )}
    </div>
  );
}

function SenderInbox(props: any) {
  const classes = useStyles();
  const [chatHeads, setChatHeads] = useState<Array<any>>([]);
  const [chatHeadsAccepter, setChatHeadsAccepter] = useState<Array<any>>([]);
  const [chatHeadsTransporter, setChatHeadsTransporter] = useState<Array<any>>(
    []
  );

  const [typingUsers, setTypingUsers] = useState<Array<any>>([]);
  const params = useParams();

  const selector = useSelector((state: RootState) => state.mainApp);
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      user: getDataFromLocalStorage("user"),
      loading_screen: true,
      showCustomerChat: false,
      showAccepterChat: false,
      drawerOpen: false,
    }
  );
  const theme = useTheme();

  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));

  useEffect(() => {
    handleGetAllChats();
    // eslint-disable-next-line
  }, []);
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (params?.tab_id) {
      if (Number(params?.tab_id) === 0) {
        setValue(0);
        return;
      }
      if (Number(params?.tab_id) === 1) {
        setValue(1);
        return;
      }
    }
  }, [params]);

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  useEffect(() => {
    if (params?.ship_id && !params?.receiver) {
      const targetId =
        (params?.tab_id?.length ?? 0) > 1 ? params?.tab_id : params?.ship_id;

      const selectChat = chatHeads?.find(
        (i: any) => Number(i?.ship_id) === Number(targetId)
      );

      handleGetShipmentRates(selectChat);

      return;
    }
    const selectedItem = chatHeads?.filter(
      (i: any) => Number(i?.ship_id) === Number(params?.ship_id)
    );

    let findRelatedChat = selectedItem.find(
      (a: any) => Number(a.accepter_id ?? 0) === Number(params?.receiver ?? 0)
    );
    if (findRelatedChat) {
      handleGetShipmentRates(findRelatedChat);
    }

    // eslint-disable-next-line
  }, [chatHeads, params?.ship_id, params.receiver]);

  // eslint-disable-next-line
  useEffect(() => {}, [selector]);

  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const screen = queryParams.get("screen"); // "messaging"
  // const resId = queryParams.get("res_id"); // "391302"

  const handleGetAllChats = async () => {
    try {
      let resp = await apiServices.getFromApi("chat/all-chat-heads", "");

      const accepterChats = resp?.data?.filter(
        (i: any) => Number(i?.product_owner) === Number(state?.user?.id)
      );
      const transporterChat = resp?.data?.filter(
        (i: any) => Number(i?.product_owner) !== Number(state?.user?.id)
      );
      setChatHeadsAccepter(accepterChats);
      setChatHeadsTransporter(transporterChat);

      setChatHeads(resp?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const [filteredChats, setFilteredChats] = useState<Array<any>>([]);
  const [searchQuery, setSearchQuery] = useState("");

  // const filterChats = _.debounce((query) => {
  //   if (value === 0) {
  //     if (!query) {
  //       const accepterChats = chatHeads?.filter(
  //         (i: any) => Number(i?.product_owner) === Number(state?.user?.id)
  //       );
  //       setChatHeadsAccepter(accepterChats);
  //     } else {
  //       const filtered = chatHeadsAccepter?.filter((chat) =>
  //         chat?.item_name_fr?.toLowerCase()?.includes(query?.toLowerCase())
  //       );
  //       setChatHeadsAccepter(filtered);
  //     }
  //   } else {
  //     if (!query) {
  //       const transporterChat = chatHeads?.filter(
  //         (i: any) => Number(i?.product_owner) !== Number(state?.user?.id)
  //       );
  //       setChatHeadsTransporter(transporterChat);
  //     } else {
  //       const filtered = chatHeadsTransporter?.filter((chat) =>
  //         chat?.item_name_fr?.toLowerCase()?.includes(query?.toLowerCase())
  //       );
  //       setChatHeadsTransporter(filtered);
  //     }
  //   }
  // }, 1);


  const filterChats = (query: string) => {
    if (value === 0) {
      if (!query) {
        const accepterChats = chatHeads?.filter(
          (i: any) => Number(i?.product_owner) === Number(state?.user?.id)
        );
        // console.log("accepterChats",accepterChats);

        setChatHeadsAccepter(accepterChats);
      } else {
        const filtered = chatHeadsAccepter?.filter((chat) =>
          chat?.shipment_items?.[0]?.item_name_fr
            ?.toLowerCase()
            ?.includes(query?.toLowerCase())
        );
        setChatHeadsAccepter(filtered);
      }
    } else {
      if (!query) {
        const transporterChat = chatHeads?.filter(
          (i: any) => Number(i?.product_owner) !== Number(state?.user?.id)
        );
        setChatHeadsTransporter(transporterChat);
      } else {
        const filtered = chatHeadsTransporter?.filter((chat) =>
          chat?.shipment_items?.[0]?.item_name_fr
            ?.toLowerCase()
            ?.includes(query?.toLowerCase())
        );
        setChatHeadsTransporter(filtered);
      }
    }
  };

  // Call the debounce function whenever searchQuery changes
  useEffect(() => {
    filterChats(searchQuery);
  }, [searchQuery, filterChats]);

  React.useEffect(() => {
    const typingQuery = query(
      collection(firestoreDB, "typing_status"),
      // where("chatId", "in", [
      //   `${announcement_details?.receiver_id ?? ""}_${user?.id ?? ""}`,
      //   `${user?.id ?? ""}_${announcement_details?.receiver_id ?? ""}`,
      // ]),
      // where("resource_id", "==", `${announcement_details?.id}`),
      // where("user_id", "!=", `${user?.id}`),
      where("isTyping", "==", true)
    );

    const unsubscribe = onSnapshot(typingQuery, (snapshot) => {
      const users = snapshot.docs.map((doc) => doc.data());
      if (users.length > 0) {
        setTypingUsers(users);
      } else {
        setTypingUsers([]);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleGetShipmentRates = async (item: any, index?: any) => {
    try {
      // setState({ loading: true });
      if (item?.type === "market_place") {
        let obj: any = {
          id: Number(item?.product_id),
          customer_id: Number(selector?.user?.id),
        };
        const resp = await apiServices.postFromApi(
          "/c2c-product-masters/particular/details",
          obj,
          ""
        );
        let receiver_id;

        if (!item?.is_owner) {
          receiver_id = item?.product_owner;
          setState({ loading: false });
        } else {
          receiver_id = item?.customer_id;
          setState({ loading: false });
        }

        setState({
          chat_type: "market_place",
          chat_details: resp?.data,
          selected_item: item,
          market_place_chat_item: {
            ...resp?.data,
            product_id: resp?.data?.id,
            receiver_id,
            customer_id: item?.customer_id,
            re_render: new Date().getTime(),
            loading: false,
          },
        });

        return;
      }

      if (item?.type === "announcement") {
        let obj: any = {
          id: Number(item?.ship_id),
          customer_id: Number(selector?.user?.id),
        };

        const resp = await apiServices.postFromApi(
          `c2c-shipments/details`,
          obj,
          ""
        );

        let receiver_id;

        if (!item?.is_owner) {
          receiver_id = item?.product_owner;
        } else {
          receiver_id = item?.accepter_id;
        }
        setState({
          chat_details: { ...resp?.data, selected_index: index },
          announcement_details: {
            ...resp?.data,
            product_id: resp?.data?.id,
            receiver_id,
            customer_id: item?.accepter_id,
            re_render: new Date().getTime(),
            loading: false,
          },
          chat_type: item?.type,
          selected_item: item,
          market_place_chat_item: null,
          loading: false,
        });

        return;
      }
    } catch (error) {
      console.log(error);
      setState({ loading: false });
    }
  };

  React.useEffect(() => {
    if (selector.messaging) {
      const message = JSON.parse(selector.messaging ?? "{}");
      if (message.navigation_id) {
        if (state.selected_item) {
          handleGetShipmentRates(state.selected_item);
        }
      }
    }
    // eslint-disable-next-line
  }, [selector.messaging]);

  const renderAnnounceCard = () =>
    state?.chat_details?.shipment_items?.length > 1 ? (
      <div>
        <div style={{ display: "flex" }}>
          <p
            style={{
              fontFamily: "montserrat-Bold",
              color: "#000",
              fontSize: screen_1024 ? "20px" : "14px",
              margin: 0,
              flex: 1,
              marginBottom: 10,
            }}
          >
            {state?.chat_details?.acc_id === state?.user?.id
              ? state?.chat_details?.user_details?.cus_name
              : state?.chat_details?.acc_name}
          </p>
          <p
            style={{
              fontFamily: "montserrat-Regular",
              fontSize: "16px",
              color: "#4B4A61",
              margin: 0,
            }}
          >
            {" "}
            Membre depuis 2025
          </p>
        </div>
        <div
          className="card-container"
          style={{
            marginTop: 5,
            background: "#fff",
            borderBottom: "1px solid #E9E8EB",
            borderRadius: 0,
          }}
          onClick={() => {
            if (state?.drawerOpen) {
              setState({ drawerOpen: false });
            } else {
              setState({ drawerOpen: true });
            }
          }}
        >
          <img
  src={
    state?.chat_details?.shipment_items?.[0]?.prod_images?.[0] ?? noImage
  }
  className="card-image"
  alt="prod-img"
  onError={(e) => {
    e.currentTarget.onerror = null; // Prevent infinite loop
    e.currentTarget.src = noImage;
  }}
/>

          <div className="card-details">
            <div className="card-title" style={{ fontSize: 18 }}>
              {`${state?.chat_details?.shipment_items?.length} articles`}
              <span
                style={{
                  color: "#78778A",
                  fontFamily: "montserrat-Regular",
                  fontSize: 12,
                  marginLeft: 1,
                }}
              >
                {" "}
                {state?.chat_details?.shipment_items
                  ?.map((item: any) => item.item_name_fr)
                  .join(", ")}
              </span>
            </div>
            <div
              className="card-quantity"
              style={{
                color: defaultLabelColors.main_orange,
                display: "flex",
                alignItems: "center",
                flex: 1,
              }}
            >
              <p
                style={{
                  fontFamily: "montserrat-Regular",
                  fontWeight: "700",
                  fontSize: "22px",
                  color: defaultLabelColors.main_orange,
                  marginBottom: 0,
                }}
              >
                {currencyFormat(
                  state?.chat_details?.agree_ship_price
                    ? state?.chat_details?.agree_ship_price
                    : state?.chat_details?.ship_price
                )}{" "}
                €
              </p>
            </div>
          </div>
          <div
            style={{
              fontFamily: "montserrat-Regular",
              fontWeight: "700",
              fontSize: "22px",
              color: defaultLabelColors.main_orange,
            }}
          >
            <p
              style={{
                color: "#080626",
                font: "14px",
                fontWeight: "500",
                fontFamily: "montserrat-SemiBold",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  borderRadius: 8,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: "montserrat-SemiBold",
                  color:
                    state?.chat_details?.ship_status === "Placed"
                      ? defaultLabelColors.main_orange_new
                      : "#166534",
                  background:
                    state?.chat_details?.ship_status === "Placed"
                      ? "#FFDCCD"
                      : "#22C55E33",
                  padding: "4px 12px",
                }}
              >
                {state?.chat_details?.user_details?.id === state?.user?.id
                  ? state?.chat_details?.ship_status === "Accepted" &&
                    state?.chat_details?.payment_status === "Paid"
                    ? "Payée"
                    : state?.chat_details?.ship_status === "Accepted"
                    ? "Acceptée"
                    : state?.chat_details?.ship_status === "Picked"
                    ? "Expédiée"
                    : state?.chat_details?.ship_status === "Deliver"
                    ? "Livré"
                    : "En ligne"
                  : state?.chat_details?.ship_status === "Accepted"
                  ? "Acceptée"
                  : state?.chat_details?.ship_status === "Picked"
                  ? "Expédiée"
                  : state?.chat_details?.ship_status === "Deliver"
                  ? "Livré"
                  : "En ligne"}
              </div>
            </p>
          </div>
        </div>
      </div>
    ) : (
      <>
        <div style={{ display: "flex" }}>
          <p
            style={{
              fontFamily: "montserrat-Bold",
              color: "#000",
              fontSize: "20px",
              margin: 0,
              flex: 1,
              marginBottom: 10,
            }}
          >
            {state?.chat_details?.acc_id === state?.user?.id
              ? state?.chat_details?.user_details?.cus_name
              : state?.chat_details?.acc_name}
          </p>
          <p
            style={{
              fontFamily: "montserrat-Regular",
              fontSize: "16px",
              color: "#4B4A61",
              margin: 0,
            }}
          >
            {" "}
            Membre depuis 2025
          </p>
        </div>
        <div
          className="card-container"
          style={{
            background: "#fff",
            cursor: "pointer",
            borderBottom: "1px solid #E9E8EB",
            borderRadius: 0,
            fontFamily: "montserrat-SemiBold",
            color: defaultLabelColors.main_font,
            fontSize: "24px",
          }}
          onClick={() => {
            if (state?.drawerOpen) {
              setState({ drawerOpen: false });
            } else {
              setState({ drawerOpen: true });
            }
          }}
        >
          <img
  src={
    state?.chat_details?.shipment_items?.[0]?.prod_images?.[0] ?? noImage
  }
  className="card-image"
  alt="prod-img"
  onError={(e) => {
    e.currentTarget.onerror = null; // Prevent infinite loop
    e.currentTarget.src = noImage;
  }}
/>

          <div className="card-details" style={{ flex: 1 }}>
            <div className="card-title" style={{ fontSize: 20 }}>
              {handleLocalize({
                en: state?.selected_item?.product_title?.en,
                fr: state?.selected_item?.product_title?.fr,
              }) ??
                state?.chat_details?.shipment_items?.[0]?.prod_name ??
                ""}
            </div>

            <div
              className="card-quantity"
              style={{
                color: defaultLabelColors.main_orange,
                display: "flex",
                alignItems: "center",
                flex: 1,
              }}
            >
              <p
                style={{
                  fontFamily: "montserrat-Regular",
                  fontWeight: "700",
                  fontSize: "22px",
                  color: defaultLabelColors.main_orange,
                  marginBottom: 0,
                }}
              >
                {numberFormatWithoutCurrencyFixed(
                  state?.chat_details?.agree_ship_price
                    ? state?.chat_details?.agree_ship_price
                    : state?.chat_details?.ship_price
                )}{" "}
                €
              </p>
            </div>
          </div>
          <div
            style={{
              fontFamily: "montserrat-Regular",
              fontWeight: "700",
              fontSize: "22px",
              color: defaultLabelColors.main_orange,
            }}
          >
            <p
              style={{
                color: "#080626",
                font: "14px",
                fontWeight: "500",
                fontFamily: "montserrat-SemiBold",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  borderRadius: 8,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: "montserrat-SemiBold",
                  color:
                    state?.chat_details?.ship_status === "Placed"
                      ? defaultLabelColors.main_orange_new
                      : "#166534",
                  background:
                    state?.chat_details?.ship_status === "Placed"
                      ? "#FFDCCD"
                      : "#22C55E33",
                  padding: "4px 12px",
                }}
              >
                {state?.chat_details?.user_details?.id === state?.user?.id
                  ? state?.chat_details?.ship_status === "Accepted" &&
                    state?.chat_details?.payment_status === "Paid"
                    ? "Payée"
                    : state?.chat_details?.ship_status === "Accepted"
                    ? "Acceptée"
                    : state?.chat_details?.ship_status === "Picked"
                    ? "Expédiée"
                    : state?.chat_details?.ship_status === "Deliver"
                    ? "Livré"
                    : "En ligne"
                  : state?.chat_details?.ship_status === "Accepted"
                  ? "Acceptée"
                  : state?.chat_details?.ship_status === "Picked"
                  ? "Expédiée"
                  : state?.chat_details?.ship_status === "Deliver"
                  ? "Livré"
                  : "En ligne"}
              </div>
            </p>
          </div>
        </div>
      </>
    );
  const renderAnnounceCardForTab = () =>
    state?.chat_details?.shipment_items?.length > 1 ? (
      <div>
        {/* Header: Name and "Membre depuis" */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontFamily: "montserrat-Bold",
              color: "#000",
              fontSize: screen_1024 ? "20px" : "14px",
              margin: 0,
            }}
          >
            {state?.chat_details?.acc_id === state?.user?.id
              ? state?.chat_details?.user_details?.cus_name
              : state?.chat_details?.acc_name}
          </p>
          <p
            style={{
              fontFamily: "montserrat-Regular",
              fontSize: "14px",
              color: "#4B4A61",
              margin: 0,
            }}
          >
            Membre depuis 2025
          </p>
        </div>

        {/* Card */}
        <div
          style={{
            marginTop: 10,
            background: "#F4F3F6",
            borderBottom: "1px solid #E9E8EB",
            borderRadius: 16,
            padding: 12,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setState({ drawerOpen: !state.drawerOpen })}
        >
          {/* Left Image */}
          <img
            src={state?.chat_details?.shipment_items?.[0]?.prod_images[0]}
            alt="prod-img"
            style={{
              width: 80,
              height: 80,
              borderRadius: 12,
              objectFit: "cover",
              marginRight: 16,
            }}
          />

          {/* Right Content */}
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            {/* Title and Price */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div>
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#080626",
                    margin: 0,
                    fontFamily: "montserrat-SemiBold",
                  }}
                >
                  {`${state?.chat_details?.shipment_items?.length} articles`}
                </p>

                <p
                  style={{
                    fontSize: 10,
                    color: "#78778A",
                    fontFamily: "montserrat-Regular",
                    margin: "4px 0 0 0",
                    lineHeight: 1.4,
                  }}
                >
                  {state?.chat_details?.shipment_items
                    ?.map((item: any) => item.item_name_fr)
                    .join(", ")}
                </p>
              </div>

              <div style={{ textAlign: "right" }}>
                <p
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    fontFamily: "montserrat-SemiBold",
                    color: defaultLabelColors.main_orange,
                    margin: 0,
                  }}
                >
                  {currencyFormat(
                    state?.chat_details?.agree_ship_price ??
                      state?.chat_details?.ship_price
                  )}{" "}
                  €
                </p>
              </div>
            </div>

            {/* Status Badge */}
            <div style={{ marginTop: 10 }}>
              <span
                style={{
                  fontSize: "14px",
                  borderRadius: 8,
                  display: "inline-block",
                  padding: "4px 12px",
                  fontFamily: "montserrat-SemiBold",
                  color:
                    state?.chat_details?.ship_status === "Placed"
                      ? defaultLabelColors.main_orange_new
                      : "#166534",
                  background:
                    state?.chat_details?.ship_status === "Placed"
                      ? "#FFDCCD"
                      : "#22C55E33",
                }}
              >
                {state?.chat_details?.user_details?.id === state?.user?.id
                  ? state?.chat_details?.ship_status === "Accepted" &&
                    state?.chat_details?.payment_status === "Paid"
                    ? "Payée"
                    : state?.chat_details?.ship_status === "Accepted"
                    ? "Acceptée"
                    : state?.chat_details?.ship_status === "Picked"
                    ? "Expédiée"
                    : state?.chat_details?.ship_status === "Deliver"
                    ? "Livré"
                    : "En ligne"
                  : state?.chat_details?.ship_status === "Accepted"
                  ? "Acceptée"
                  : state?.chat_details?.ship_status === "Picked"
                  ? "Expédiée"
                  : state?.chat_details?.ship_status === "Deliver"
                  ? "Livré"
                  : "En ligne"}
              </span>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <>
        <div style={{ display: "flex" }}>
          <p
            style={{
              fontFamily: screen_1024
                ? "montserrat-Bold"
                : "montserrat-SemiBold",
              color: "#000",
              fontSize: screen_1024 ? "20px" : "14px",
              margin: 0,
              flex: 1,
              marginBottom: 10,
            }}
          >
            {state?.chat_details?.acc_id === state?.user?.id
              ? state?.chat_details?.user_details?.cus_name
              : state?.chat_details?.acc_name}
          </p>
          <p
            style={{
              fontFamily: "montserrat-Regular",
              fontSize: screen_1024 ? "16px" : "12px",
              color: "#4B4A61",
              margin: 0,
            }}
          >
            {" "}
            Membre depuis 2025
          </p>
        </div>
        <div
          className="card-container"
          style={{
            background: "#F4F3F6",
            cursor: "pointer",
            borderRadius: 16,
            padding: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontFamily: "montserrat-SemiBold",
            color: defaultLabelColors.main_font,
            fontSize: "16px",
            marginTop: "10px",
          }}
          onClick={() => {
            setState({ drawerOpen: !state?.drawerOpen });
          }}
        >
          <img
            src={
              state?.chat_details?.shipment_items?.[0]?.prod_images?.[0] ??
              state?.selected_item?.images?.[0] ??
              noImage
            }
            className="card-image"
            alt="prod-img"
            style={{
              width: 80,
              height: 80,
              borderRadius: 12,
              objectFit: "contain",
              marginRight: 16,
            }}
          />

          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#080626",
                    marginBottom: 4,
                  }}
                >
                  {handleLocalize({
                    en: state?.selected_item?.product_title?.en,
                    fr: state?.selected_item?.product_title?.fr,
                  }) ??
                    state?.chat_details?.shipment_items?.[0]?.prod_name ??
                    ""}
                </div>

                <div
                  style={{
                    fontSize: 12,
                    fontFamily: "montserrat-Regular",
                    color: "#8C89A9",
                    marginBottom: 6,
                  }}
                >
                  Offre initiale :{" "}
                  {numberFormatWithoutCurrencyFixed(
                    state?.chat_details?.ship_price ?? 0
                  )}{" "}
                  €
                </div>

                <div
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    textAlign: "center",
                    color:
                      state?.chat_details?.ship_status === "Placed"
                        ? defaultLabelColors.main_orange_new
                        : "#166534",
                    background:
                      state?.chat_details?.ship_status === "Placed"
                        ? "#FFDCCD"
                        : "#22C55E33",
                    padding: "4px 12px",
                    borderRadius: 12,
                    display: "inline-block",
                    maxWidth: "50%",
                  }}
                >
                  {state?.chat_details?.user_details?.id === state?.user?.id
                    ? state?.chat_details?.ship_status === "Accepted" &&
                      state?.chat_details?.payment_status === "Paid"
                      ? "Payée"
                      : state?.chat_details?.ship_status === "Accepted"
                      ? "Acceptée"
                      : state?.chat_details?.ship_status === "Picked"
                      ? "Expédiée"
                      : state?.chat_details?.ship_status === "Deliver"
                      ? "Livré"
                      : "En ligne"
                    : state?.chat_details?.ship_status === "Accepted"
                    ? "Acceptée"
                    : state?.chat_details?.ship_status === "Picked"
                    ? "Expédiée"
                    : state?.chat_details?.ship_status === "Deliver"
                    ? "Livré"
                    : "En ligne"}
                </div>
              </div>

              <div style={{ textAlign: "right" }}>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: "#F26322", // Orange
                  }}
                >
                  {numberFormatWithoutCurrencyFixed(
                    state?.chat_details?.agree_ship_price
                      ? state?.chat_details?.agree_ship_price
                      : state?.chat_details?.ship_price
                  )}{" "}
                  €
                </div>
                <div
                  style={{
                    fontSize: 12,
                    fontFamily: "montserrat-Regular",
                    color: "#8C89A9",
                    marginTop: 30,
                  }}
                >
                  {new Date(state?.chat_details?.created_at).toLocaleDateString(
                    "fr-FR"
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );

  const renderChatHeadItem = (is_typing: boolean, item: any, index: number) => {
    return (
      <div
        style={{
          display: "flex",
          padding: "16px",
          borderRadius: 24,
          background:
            String(item?.ship_id) === String(state?.chat_details?.id) &&
            Number(index) === Number(state?.chat_details?.selected_index) &&
            screen_1024
              ? "#F4F3F6"
              : "#fff",
          cursor: "pointer",
          gap: 10,
        }}
        key={`CHAT_HEAD_${index + 1}`}
        onClick={() => {
          handleGetShipmentRates(item, index);
          if (!screen_1024) {
            setState({ chat_tab: true });
          }
        }}
      >
        <div
          style={{
            height: 60,
            width: 60,
          }}
        >
          <img
            alt="item-img"
            src={item?.shipment_items?.[0]?.prod_images?.[0] ?? noImage}
            onError={(e) => {
    e.currentTarget.onerror = null; // prevent infinite loop if noImage also fails
    e.currentTarget.src = noImage;
    e.currentTarget.style.objectFit = "contain"; // fallback style if needed
  }}
            style={
              item?.shipment_items?.[0]?.prod_images?.[0] ?? item?.images?.[0]
                ? {
                    height: 50,
                    width: 50,
                    objectFit: "cover",
                    borderRadius: 100,
                    border: `1px solid #0000001f`,
                  }
                : {
                    height: 50,
                    width: 50,
                    objectFit: "contain",
                    borderRadius: 100,
                    border: `1px solid #0000001f`,
                  }
            }
          />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            rowGap: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
            }}
          >
            <div
              style={{
                fontSize: 16,
                fontFamily: "montserrat-SemiBold",
                color: defaultLabelColors.main_font,
                flex: 1,
              }}
            >
              {item?.shipment_items?.length > 1
                ? `${item?.shipment_items?.length} articles`
                : item.type === "announcement"
                ? handleLocalize({
                    en: item?.shipment_items?.[0]?.item_name_en,
                    fr: item?.shipment_items?.[0]?.item_name_fr,
                  })
                : handleLocalize(item.product_title)}
            </div>

            <div
              style={{
                padding: "4px 12px",
                fontSize: 12,
                fontFamily: "montserrat-SemiBold",
                background:
                  item?.ship_status === "Placed"
                    ? "#FFDCCD"
                    : item?.is_accepted === false
                    ? "#22C55E33"
                    : "#22C55E33",
                color:
                  item?.ship_status === "Placed"
                    ? "#EE6931"
                    : item?.is_accepted === false
                    ? "#166534"
                    : "#166534",
                minWidth: 56,
                borderRadius: 8,
                textAlign: "center",
              }}
            >
              {item?.product_owner === state?.user?.id &&
              item.ship_status === "Accepted" &&
              item?.payment_status === "Paid"
                ? "Payée"
                : item.ship_status === "Accepted"
                ? "Acceptée"
                : item.ship_status === "Deliver"
                ? "Livré"
                : item.ship_status === "Picked"
                ? "Expédiée"
                : "En ligne"}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
            }}
          >
            <div
              style={{
                flex: 1,
                color: "#4B4A61",
                fontSize: 14,
                fontFamily: "montserrat-Regular",
              }}
            >
              {is_typing ? "typing..." : item?.added_by}
            </div>
            <div
              style={{
                fontSize: 12,
                fontFamily: "montserrat-Regular",
                color: defaultLabelColors.main_font_grey,
              }}
            >
              {moment(
                `${item.created_at}`.endsWith("Z")
                  ? item.created_at
                  : item.created_at + "Z"
              ).format("DD/MM/YYYY")}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Loader loading={state?.loading} />
      <Helmet>
        <title>Le Chat | Discutez avec la Communauté Frank</title>
        <link rel="canonical" href="https://www.frank.fr/chat" />
        <link
          rel="icon"
          type="image/png"
          href="/frank_favicon.png"
        />
        <meta
          name="description"
          content="Discutez en temps réel avec d'autres membres de la communauté Frank. Partagez vos expériences et restez connecté avec des transporteurs et clients."
        />
      </Helmet>
      <div className="web-screen">
        <div
          style={{
            background: defaultLabelColors.main_background_new,
            justifyItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              maxWidth: 1408,
              width: "100%",
            }}
          >
            <NewHeader />
            <div
              style={{
                paddingTop: 140,
                paddingBottom: 30,
                paddingLeft: 40,
                paddingRight: 40,
              }}
            >
              <Grid container spacing={2}>
                {screen_1024 ? (
                  <>
                    <Grid item xs={12} md={4}>
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "16px",
                          padding: "16px",
                          display: "flex",
                          flexDirection: "column",
                          height: "90vh",
                        }}
                        className={classes?.scrollableArea}
                      >
                        <div
                          style={{
                            display: "flex",
                            // justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <h2
                            style={{
                              fontFamily: "montserrat-Bold",
                              fontSize: screen_1024 ? "28px" : "20px",
                              margin: 0,
                              textAlign: "left",
                            }}
                          >
                            {strings?.inbox}
                          </h2>

                          <InputField
                            placeHolder={"Rechercher un message"}

                            isDisable={false}
                            onchange={(e: any) =>
                              setSearchQuery(e.target.value)
                            }
                            startIcon={
                              <SearchIconforAnnounces color="#8F8E9C" />
                            }
                            input_value={searchQuery}
                            input_name={"searched_chat"}
                            input_style={{
                              background: "#F4F3F6",
                              borderRadius: 12,
                              marginTop: 24,
                            }}
                          />
                        </div>
                        <Box sx={{ width: "100%" }}>
                          <Box
                            sx={{
                              width: "100%",
                              borderBottom: 1,
                              borderColor: "divider",
                            }}
                          >
                            <Tabs
                              value={value}
                              onChange={handleChange}
                              aria-label="basic tabs example"
                              sx={{ width: "100%" }}
                              TabIndicatorProps={{
                                style: {
                                  backgroundColor:
                                    defaultLabelColors?.main_orange_new,
                                  color: defaultLabelColors?.main_orange_new,
                                  // height: 4,
                                  // marginLeft: 10,
                                },
                              }}
                              // Ensure the Tabs container takes full width
                            >
                              <Tab
                                label="Mes annonces"
                                {...a11yProps(0)}
                                sx={{
                                  width: "50%",
                                  maxWidth: "50% !important",
                                  fontFamily: "montserrat-Regular",
                                  textTransform: "none",
                                  color: "#000",
                                  fontSize: 16,

                                  "&.Mui-selected": {
                                    color: "#000",
                                    fontFamily: "montserrat-SemiBold",
                                  },
                                }}
                              />
                              <Tab
                                label="Mes trajets"
                                {...a11yProps(1)}
                                sx={{
                                  width: "50%",
                                  maxWidth: "50% !important",
                                  fontFamily: "montserrat-Regular",
                                  textTransform: "none",
                                  fontSize: 16,

                                  "&.Mui-selected": {
                                    color: "#000",
                                    fontFamily: "montserrat-SemiBold",
                                  },
                                }}
                              />
                            </Tabs>
                          </Box>

                          <CustomTabPanel value={value} index={0}>
                            {filteredChats?.length > 0
                              ? filteredChats?.map((item: any, index: any) => {
                                  const is_typing = typingUsers.find(
                                    (a: any) =>
                                      (Number(a.resource_id) ===
                                        Number(item?.ship_id) ||
                                        Number(a.resource_id) ===
                                          Number(item?.product_id)) &&
                                      Number(a.user_id) !==
                                        Number(state?.user?.id) &&
                                      (item?.is_owner
                                        ? a.chatId ===
                                            `${item.accepter_id}_${state.user?.id}` ||
                                          a.chatId ===
                                            `${state.user?.id}_${item.accepter_id}`
                                        : true)
                                  );

                                  return (
                                    <div>
                                      {renderChatHeadItem(
                                        is_typing,
                                        item,
                                        index
                                      )}
                                      {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  cursor: "pointer",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                    </div>
                                  );
                                })
                              : chatHeadsAccepter?.map(
                                  (item: any, index: any) => {
                                    // eslint-disable-next-line
                                    // let item_name = "";
                                    // if (item?.shipment_items?.length > 1) {
                                    //   item_name = item?.shipment_items?.[0]?.item_name_fr;
                                    // } else {
                                    //   item_name = item?.shipment_items?.[0]?.item_name_en;
                                    // }
                                    const is_typing = typingUsers.find(
                                      (a: any) =>
                                        (Number(a.resource_id) ===
                                          Number(item?.ship_id) ||
                                          Number(a.resource_id) ===
                                            Number(item?.product_id)) &&
                                        Number(a.user_id) !==
                                          Number(state?.user?.id) &&
                                        (item?.is_owner
                                          ? a.chatId ===
                                              `${item.accepter_id}_${state.user?.id}` ||
                                            a.chatId ===
                                              `${state.user?.id}_${item.accepter_id}`
                                          : true)
                                    );

                                    return (
                                      <div>
                                        {renderChatHeadItem(
                                          is_typing,
                                          item,
                                          index
                                        )}

                                        {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  cursor: "pointer",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                      </div>
                                    );
                                  }
                                )}
                          </CustomTabPanel>

                          <CustomTabPanel value={value} index={1}>
                            {filteredChats?.length > 0
                              ? filteredChats?.map((item: any, index: any) => {
                                  const is_typing = typingUsers.find(
                                    (a: any) =>
                                      (Number(a.resource_id) ===
                                        Number(item?.ship_id) ||
                                        Number(a.resource_id) ===
                                          Number(item?.product_id)) &&
                                      Number(a.user_id) !==
                                        Number(state?.user?.id) &&
                                      (item?.is_owner
                                        ? a.chatId ===
                                            `${item.accepter_id}_${state.user?.id}` ||
                                          a.chatId ===
                                            `${state.user?.id}_${item.accepter_id}`
                                        : true)
                                  );

                                  return (
                                    <>
                                      {renderChatHeadItem(
                                        is_typing,
                                        item,
                                        index
                                      )}

                                      {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  cursor: "pointer",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                    </>
                                  );
                                })
                              : chatHeadsTransporter?.map(
                                  (item: any, index: any) => {
                                    // eslint-disable-next-line
                                    // let item_name = "";
                                    // if (item?.shipment_items?.length > 1) {
                                    //   item_name = item?.shipment_items?.[0]?.item_name_fr;
                                    // } else {
                                    //   item_name = item?.shipment_items?.[0]?.item_name_en;
                                    // }
                                    const is_typing = typingUsers.find(
                                      (a: any) =>
                                        (Number(a.resource_id) ===
                                          Number(item?.ship_id) ||
                                          Number(a.resource_id) ===
                                            Number(item?.product_id)) &&
                                        Number(a.user_id) !==
                                          Number(state?.user?.id) &&
                                        (item?.is_owner
                                          ? a.chatId ===
                                              `${item.accepter_id}_${state.user?.id}` ||
                                            a.chatId ===
                                              `${state.user?.id}_${item.accepter_id}`
                                          : true)
                                    );

                                    return (
                                      <>
                                        {renderChatHeadItem(
                                          is_typing,
                                          item,
                                          index
                                        )}

                                        {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  cursor: "pointer",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                     
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                      </>
                                    );
                                  }
                                )}
                          </CustomTabPanel>
                        </Box>

                        {/* <Box
                    sx={{
                      flex: 1,
                      backgroundColor: "white",
                      overflowY: "scroll",
                      maxHeight: "90vh",
                    }}
                  >
                    {chatHeads?.map((item: any, index: any) => {
                      // eslint-disable-next-line
                      // let item_name = "";
                      // if (item?.shipment_items?.length > 1) {
                      //   item_name = item?.shipment_items?.[0]?.item_name_fr;
                      // } else {
                      //   item_name = item?.shipment_items?.[0]?.item_name_en;
                      // }
                      const is_typing = typingUsers.find(
                        (a: any) =>
                          (Number(a.resource_id) === Number(item?.ship_id) ||
                            Number(a.resource_id) ===
                              Number(item?.product_id)) &&
                          Number(a.user_id) !== Number(state?.user?.id) &&
                          (item?.is_owner
                            ? a.chatId ===
                                `${item.accepter_id}_${state.user?.id}` ||
                              a.chatId ===
                                `${state.user?.id}_${item.accepter_id}`
                            : true)
                      );

                      return (
                        <>
                          <div
                            style={{
                              display: "flex",
                              padding: "10px",
                              cursor: "pointer",
                              gap: 10,
                            }}
                            key={`CHAT_HEAD_${index + 1}`}
                            onClick={() => handleGetShipmentRates(item)}
                          >
                            <div
                              style={{
                                height: 60,
                                width: 60,
                              }}
                            >
                              <img
                                alt="item-img"
                                src={item?.images?.[0] ?? noImage}
                                style={
                                  item?.shipment_items?.[0]?.images?.[0] ??
                                  item?.images?.[0]
                                    ? {
                                        height: 50,
                                        width: 50,
                                        objectFit: "contain",
                                        borderRadius: 100,
                                        border: `1px solid #0000001f`,
                                      }
                                    : {
                                        height: 50,
                                        width: 50,
                                        objectFit: "contain",
                                        borderRadius: 100,
                                        border: `1px solid #0000001f`,
                                      }
                                }
                              />
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                rowGap: 10,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "baseline",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 18,
                                    fontFamily: "Raleway-Bold",
                                    color: color_theme.black,
                                    flex: 1,
                                  }}
                                >
                                  {item.type === "announcement"
                                    ? handleLocalize({
                                        en: item?.item_name_en,
                                        fr: item?.item_name_fr,
                                      })
                                    : handleLocalize(item.product_title)}
                                  <span
                                    style={{
                                      color:
                                        item.type === "announcement"
                                          ? color_theme.main_blue
                                          : color_theme.main_orange,
                                      fontSize: 12,
                                      marginLeft: 5,
                                    }}
                                  >
                                    •{" "}
                                    {item.type === "announcement"
                                      ? item?.is_owner
                                        ? "À envoyer"
                                        : "À transporter"
                                      : "Seconde main"}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    padding: "4px 12px",
                                    fontSize: 12,
                                    background:
                                      item?.is_accepted === true
                                        ? "#34A8531A"
                                        : item?.is_accepted === false
                                        ? "#1C4FDC1A"
                                        : "#1C4FDC1A",
                                    color:
                                      item?.is_accepted === true
                                        ? "#34A853"
                                        : item?.is_accepted === false
                                        ? "#1C4FDC"
                                        : "#1C4FDC",
                                    minWidth: 56,
                                    borderRadius: 8,
                                    textAlign: "center",
                                  }}
                                >
                                  {item?.is_accepted
                                    ? "Validée"
                                    : item?.is_accepted === false
                                    ? "En cours"
                                    : "En cours"}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "baseline",
                                }}
                              >
                                <div
                                  style={{
                                    flex: 1,
                                    color: "#4B4A61",
                                    fontSize: 14,
                                  }}
                                >
                                  {is_typing ? "typing..." : item?.added_by}
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    color: color_theme.black,
                                  }}
                                >
                                  {moment(
                                    `${item.created_at_tz}`.endsWith("Z")
                                      ? item.created_at_tz
                                      : item.created_at_tz + "Z"
                                  ).format("HH:mm")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </Box> */}
                      </div>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "16px",
                          padding: "16px",
                          height: "90vh",
                        }}
                      >
                        <div
                          style={{
                            height: "90vh",
                          }}
                        >
                          {
                            // state?.chat_type === "sender" ? (
                            //   <>
                            //     {renderAnnounceCard()}
                            //     <SenderChat
                            //       handleGetShipmentRates={handleGetShipmentRates}
                            //       {...props}
                            //       {...state}
                            //       handleSwitChat={() => {
                            //         setState({
                            //           chat_type: "transporter",
                            //         });
                            //       }}
                            //     />
                            //   </>
                            // ) : state?.chat_type === "transporter" ? (
                            //   <>
                            //     {renderAnnounceCard()}
                            //     <AccepterChat
                            //       handleGetShipmentRates={handleGetShipmentRates}
                            //       {...props}
                            //       {...state}
                            //     />
                            //   </>
                            // ) :
                            state.chat_type === "announcement" ? (
                              <>
                                {screen_1024
                                  ? renderAnnounceCard()
                                  : renderAnnounceCardForTab()}
                                <AnnouncementChat
                                  announcement_details={
                                    state.announcement_details
                                  }
                                  chat_details={state.chat_details}
                                />
                                {/* <AnnouncementChat
                                /> */}
                              </>
                            ) : state?.chat_type === "market_place" ? (
                              <>
                                {screen_1024
                                  ? renderAnnounceCard()
                                  : renderAnnounceCardForTab()}
                                <MarketPlaceChat
                                  handleGetShipmentRates={
                                    handleGetShipmentRates
                                  }
                                  {...props}
                                  {...state}
                                />
                              </>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    flexDirection: "column",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={noChatimage}
                                    alt="no-chat-img"
                                    style={{ opacity: "0.7" }}
                                  />
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </Grid>
                  </>
                ) : (
                  <>
                    {state?.chat_tab ? (
                      <>
                        <div style={{ display: "flex", gap: "12px" }}>
                          <div
                            className="display-flex"
                            style={{ cursor: "pointer" }}
                            onClick={() => setState({ chat_tab: false })}
                          >
                            <BackIconHalf />
                          </div>{" "}
                          <div
                            className="display-flex"
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              fontSize: "16px",
                            }}
                          >
                            {" "}
                            Retour
                          </div>
                        </div>
                        <Grid item xs={12} md={12}>
                          <div
                            style={{
                              background: "#fff",
                              borderRadius: "16px",
                              padding: "16px",
                              height: "90vh",
                            }}
                          >
                            <div
                              style={{
                                height: "90vh",
                              }}
                            >
                              {
                                // state?.chat_type === "sender" ? (
                                //   <>
                                //     {renderAnnounceCard()}
                                //     <SenderChat
                                //       handleGetShipmentRates={handleGetShipmentRates}
                                //       {...props}
                                //       {...state}
                                //       handleSwitChat={() => {
                                //         setState({
                                //           chat_type: "transporter",
                                //         });
                                //       }}
                                //     />
                                //   </>
                                // ) : state?.chat_type === "transporter" ? (
                                //   <>
                                //     {renderAnnounceCard()}
                                //     <AccepterChat
                                //       handleGetShipmentRates={handleGetShipmentRates}
                                //       {...props}
                                //       {...state}
                                //     />
                                //   </>
                                // ) :
                                state.chat_type === "announcement" ? (
                                  <>
                                    {screen_1024
                                      ? renderAnnounceCard()
                                      : renderAnnounceCardForTab()}
                                    <AnnouncementChat
                                      announcement_details={
                                        state.announcement_details
                                      }
                                      chat_details={state.chat_details}
                                    />
                                  </>
                                ) : state?.chat_type === "market_place" ? (
                                  <>
                                    {screen_1024
                                      ? renderAnnounceCard()
                                      : renderAnnounceCardForTab()}
                                    <MarketPlaceChat
                                      handleGetShipmentRates={
                                        handleGetShipmentRates
                                      }
                                      {...props}
                                      {...state}
                                    />
                                  </>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flexDirection: "column",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={noChatimage}
                                        alt="no-chat-img"
                                        style={{ opacity: "0.7" }}
                                      />
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        </Grid>
                      </>
                    ) : (
                      <>
                        {" "}
                        <Grid item xs={12} md={12}>
                          <div
                            style={{
                              background: "#fff",
                              borderRadius: "16px",
                              padding: "16px",
                              display: "flex",
                              flexDirection: "column",
                              height: "90vh",
                            }}
                            className={classes?.scrollableArea}
                          >
                            <div
                              style={{
                                display: "flex",
                                // justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              <h2
                                style={{
                                  fontFamily: "montserrat-Bold",
                                  fontSize: screen_1024 ? "28px" : "20px",
                                  margin: 0,
                                  textAlign: "left",
                                }}
                              >
                                {strings?.inbox}
                              </h2>

                              <InputField
                                placeHolder={"Rechercher un message"}
                                isDisable={false}
                                onchange={(e: any) =>
                                  setSearchQuery(e.target.value)
                                }
                                startIcon={
                                  <SearchIconforAnnounces color="#8F8E9C" />
                                }
                                input_value={searchQuery}
                                input_name={"searched_chat"}
                                input_style={{
                                  background: "#F4F3F6",
                                  borderRadius: 12,
                                  marginTop: 24,
                                }}
                              />
                            </div>
                            <Box sx={{ width: "100%" }}>
                              <Box
                                sx={{
                                  width: "100%",
                                  borderBottom: 1,
                                  borderColor: "divider",
                                }}
                              >
                                <Tabs
                                  value={value}
                                  onChange={handleChange}
                                  aria-label="basic tabs example"
                                  sx={{ width: "100%" }}
                                  TabIndicatorProps={{
                                    style: {
                                      backgroundColor:
                                        defaultLabelColors?.main_orange_new,
                                      color:
                                        defaultLabelColors?.main_orange_new,
                                      // height: 4,
                                      // marginLeft: 10,
                                    },
                                  }}
                                  // Ensure the Tabs container takes full width
                                >
                                  <Tab
                                    label="Mes annonces"
                                    {...a11yProps(0)}
                                    sx={{
                                      width: "50%",
                                      maxWidth: "50% !important",
                                      fontFamily: "montserrat-Regular",
                                      textTransform: "none",
                                      color: "#000",
                                      fontSize: 16,

                                      "&.Mui-selected": {
                                        color: "#000",
                                        fontFamily: "montserrat-SemiBold",
                                      },
                                    }}
                                  />
                                  <Tab
                                    label="Mes trajets"
                                    {...a11yProps(1)}
                                    sx={{
                                      width: "50%",
                                      maxWidth: "50% !important",
                                      fontFamily: "montserrat-Regular",
                                      textTransform: "none",
                                      fontSize: 16,

                                      "&.Mui-selected": {
                                        color: "#000",
                                        fontFamily: "montserrat-SemiBold",
                                      },
                                    }}
                                  />
                                </Tabs>
                              </Box>

                              <CustomTabPanel value={value} index={0}>
                                {filteredChats?.length > 0
                                  ? filteredChats?.map(
                                      (item: any, index: any) => {
                                        const is_typing = typingUsers.find(
                                          (a: any) =>
                                            (Number(a.resource_id) ===
                                              Number(item?.ship_id) ||
                                              Number(a.resource_id) ===
                                                Number(item?.product_id)) &&
                                            Number(a.user_id) !==
                                              Number(state?.user?.id) &&
                                            (item?.is_owner
                                              ? a.chatId ===
                                                  `${item.accepter_id}_${state.user?.id}` ||
                                                a.chatId ===
                                                  `${state.user?.id}_${item.accepter_id}`
                                              : true)
                                        );

                                        return (
                                          <>
                                            {renderChatHeadItem(
                                              is_typing,
                                              item,
                                              index
                                            )}
                                            {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  cursor: "pointer",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                          </>
                                        );
                                      }
                                    )
                                  : chatHeadsAccepter?.map(
                                      (item: any, index: any) => {
                                        // eslint-disable-next-line
                                        // let item_name = "";
                                        // if (item?.shipment_items?.length > 1) {
                                        //   item_name = item?.shipment_items?.[0]?.item_name_fr;
                                        // } else {
                                        //   item_name = item?.shipment_items?.[0]?.item_name_en;
                                        // }
                                        const is_typing = typingUsers.find(
                                          (a: any) =>
                                            (Number(a.resource_id) ===
                                              Number(item?.ship_id) ||
                                              Number(a.resource_id) ===
                                                Number(item?.product_id)) &&
                                            Number(a.user_id) !==
                                              Number(state?.user?.id) &&
                                            (item?.is_owner
                                              ? a.chatId ===
                                                  `${item.accepter_id}_${state.user?.id}` ||
                                                a.chatId ===
                                                  `${state.user?.id}_${item.accepter_id}`
                                              : true)
                                        );

                                        return (
                                          <>
                                            {renderChatHeadItem(
                                              is_typing,
                                              item,
                                              index
                                            )}

                                            {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  cursor: "pointer",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                          </>
                                        );
                                      }
                                    )}
                              </CustomTabPanel>

                              <CustomTabPanel value={value} index={1}>
                                {filteredChats?.length > 0
                                  ? filteredChats?.map(
                                      (item: any, index: any) => {
                                        const is_typing = typingUsers.find(
                                          (a: any) =>
                                            (Number(a.resource_id) ===
                                              Number(item?.ship_id) ||
                                              Number(a.resource_id) ===
                                                Number(item?.product_id)) &&
                                            Number(a.user_id) !==
                                              Number(state?.user?.id) &&
                                            (item?.is_owner
                                              ? a.chatId ===
                                                  `${item.accepter_id}_${state.user?.id}` ||
                                                a.chatId ===
                                                  `${state.user?.id}_${item.accepter_id}`
                                              : true)
                                        );

                                        return (
                                          <>
                                            {renderChatHeadItem(
                                              is_typing,
                                              item,
                                              index
                                            )}

                                            {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  cursor: "pointer",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                          </>
                                        );
                                      }
                                    )
                                  : chatHeadsTransporter?.map(
                                      (item: any, index: any) => {
                                        // eslint-disable-next-line
                                        // let item_name = "";
                                        // if (item?.shipment_items?.length > 1) {
                                        //   item_name = item?.shipment_items?.[0]?.item_name_fr;
                                        // } else {
                                        //   item_name = item?.shipment_items?.[0]?.item_name_en;
                                        // }
                                        const is_typing = typingUsers.find(
                                          (a: any) =>
                                            (Number(a.resource_id) ===
                                              Number(item?.ship_id) ||
                                              Number(a.resource_id) ===
                                                Number(item?.product_id)) &&
                                            Number(a.user_id) !==
                                              Number(state?.user?.id) &&
                                            (item?.is_owner
                                              ? a.chatId ===
                                                  `${item.accepter_id}_${state.user?.id}` ||
                                                a.chatId ===
                                                  `${state.user?.id}_${item.accepter_id}`
                                              : true)
                                        );

                                        return (
                                          <>
                                            {renderChatHeadItem(
                                              is_typing,
                                              item,
                                              index
                                            )}

                                            {/* <div
                                style={{
                                  display: "flex",
                                  padding: "16px",
                                  borderRadius: 24,
                                  background: String(item?.ship_id) === String(state?.chat_details?.id) ? '#F4F3F6' : "#fff",
                                  cursor: "pointer",
                                  gap: 10,
                                }}
                                key={`CHAT_HEAD_${index + 1}`}
                                onClick={() => handleGetShipmentRates(item)}
                              >
                                <div
                                  style={{
                                    height: 60,
                                    width: 60,
                                  }}
                                >
                                  <img
                                    alt="item-img"
                                    src={item?.images?.[0] ?? noImage}
                                    style={
                                      item?.shipment_items?.[0]
                                        ?.images?.[0] ?? item?.images?.[0]
                                        ? {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                        : {
                                          height: 50,
                                          width: 50,
                                          objectFit: "contain",
                                          borderRadius: 100,
                                          border: `1px solid #0000001f`,
                                        }
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 18,
                                        fontFamily: "montserrat-SemiBold",
                                        color: defaultLabelColors.main_font,
                                        flex: 1,
                                      }}
                                    >
                                      {item.type === "announcement"
                                        ? handleLocalize({
                                          en: item?.item_name_en,
                                          fr: item?.item_name_fr,
                                        })
                                        : handleLocalize(item.product_title)}
                                     
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px 12px",
                                        fontSize: 12,
                                        fontFamily: 'montserrat-SemiBold',
                                        background:
                                          item?.is_accepted === true
                                            ? "#22C55E33"
                                            : item?.is_accepted === false
                                              ? "#FFDCCD"
                                              : "#FFDCCD",
                                        color:
                                          item?.is_accepted === true
                                            ? "#166534"
                                            : item?.is_accepted === false
                                              ? "#EF6A31"
                                              : "#EF6A31",
                                        minWidth: 56,
                                        borderRadius: 8,
                                        textAlign: "center",
                                      }}
                                    >
                                      {item?.is_accepted
                                        ? "Acceptée"
                                        : item?.is_accepted === false
                                          ? "En ligne"
                                          : "En ligne"}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "baseline",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flex: 1,
                                        color: "#4B4A61",
                                        fontSize: 14,
                                        fontFamily: "montserrat-Regular",
                                      }}
                                    >
                                      {is_typing
                                        ? "typing..."
                                        : item?.added_by}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 12,
                                        fontFamily: 'montserrat-Regular',
                                        color: defaultLabelColors.main_font_grey,
                                      }}
                                    >
                                      {moment(
                                        `${item.created_at}`.endsWith("Z")
                                          ? item.created_at
                                          : item.created_at + "Z"
                                      ).format("DD/MM/YYYY")}
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                                          </>
                                        );
                                      }
                                    )}
                              </CustomTabPanel>
                            </Box>

                            {/* <Box
                    sx={{
                      flex: 1,
                      backgroundColor: "white",
                      overflowY: "scroll",
                      maxHeight: "90vh",
                    }}
                  >
                    {chatHeads?.map((item: any, index: any) => {
                      // eslint-disable-next-line
                      // let item_name = "";
                      // if (item?.shipment_items?.length > 1) {
                      //   item_name = item?.shipment_items?.[0]?.item_name_fr;
                      // } else {
                      //   item_name = item?.shipment_items?.[0]?.item_name_en;
                      // }
                      const is_typing = typingUsers.find(
                        (a: any) =>
                          (Number(a.resource_id) === Number(item?.ship_id) ||
                            Number(a.resource_id) ===
                              Number(item?.product_id)) &&
                          Number(a.user_id) !== Number(state?.user?.id) &&
                          (item?.is_owner
                            ? a.chatId ===
                                `${item.accepter_id}_${state.user?.id}` ||
                              a.chatId ===
                                `${state.user?.id}_${item.accepter_id}`
                            : true)
                      );

                      return (
                        <>
                          <div
                            style={{
                              display: "flex",
                              padding: "10px",
                              cursor: "pointer",
                              gap: 10,
                            }}
                            key={`CHAT_HEAD_${index + 1}`}
                            onClick={() => handleGetShipmentRates(item)}
                          >
                            <div
                              style={{
                                height: 60,
                                width: 60,
                              }}
                            >
                              <img
                                alt="item-img"
                                src={item?.images?.[0] ?? noImage}
                                style={
                                  item?.shipment_items?.[0]?.images?.[0] ??
                                  item?.images?.[0]
                                    ? {
                                        height: 50,
                                        width: 50,
                                        objectFit: "contain",
                                        borderRadius: 100,
                                        border: `1px solid #0000001f`,
                                      }
                                    : {
                                        height: 50,
                                        width: 50,
                                        objectFit: "contain",
                                        borderRadius: 100,
                                        border: `1px solid #0000001f`,
                                      }
                                }
                              />
                            </div>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                rowGap: 10,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "baseline",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 18,
                                    fontFamily: "Raleway-Bold",
                                    color: color_theme.black,
                                    flex: 1,
                                  }}
                                >
                                  {item.type === "announcement"
                                    ? handleLocalize({
                                        en: item?.item_name_en,
                                        fr: item?.item_name_fr,
                                      })
                                    : handleLocalize(item.product_title)}
                                  <span
                                    style={{
                                      color:
                                        item.type === "announcement"
                                          ? color_theme.main_blue
                                          : color_theme.main_orange,
                                      fontSize: 12,
                                      marginLeft: 5,
                                    }}
                                  >
                                    •{" "}
                                    {item.type === "announcement"
                                      ? item?.is_owner
                                        ? "À envoyer"
                                        : "À transporter"
                                      : "Seconde main"}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    padding: "4px 12px",
                                    fontSize: 12,
                                    background:
                                      item?.is_accepted === true
                                        ? "#34A8531A"
                                        : item?.is_accepted === false
                                        ? "#1C4FDC1A"
                                        : "#1C4FDC1A",
                                    color:
                                      item?.is_accepted === true
                                        ? "#34A853"
                                        : item?.is_accepted === false
                                        ? "#1C4FDC"
                                        : "#1C4FDC",
                                    minWidth: 56,
                                    borderRadius: 8,
                                    textAlign: "center",
                                  }}
                                >
                                  {item?.is_accepted
                                    ? "Validée"
                                    : item?.is_accepted === false
                                    ? "En cours"
                                    : "En cours"}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "baseline",
                                }}
                              >
                                <div
                                  style={{
                                    flex: 1,
                                    color: "#4B4A61",
                                    fontSize: 14,
                                  }}
                                >
                                  {is_typing ? "typing..." : item?.added_by}
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    color: color_theme.black,
                                  }}
                                >
                                  {moment(
                                    `${item.created_at_tz}`.endsWith("Z")
                                      ? item.created_at_tz
                                      : item.created_at_tz + "Z"
                                  ).format("HH:mm")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </Box> */}
                          </div>
                        </Grid>
                      </>
                    )}
                  </>
                )}
              </Grid>
            </div>
          </div>
        </div>

        <Drawer
          anchor="right"
          open={state?.drawerOpen}
          onClose={() => {
            setState({ drawerOpen: false });
          }}
          PaperProps={{
            sx: {
              width: 620, // Adjust width to match your design
              // padding: 2,
              borderRadius: "16px",
              // paddingRight: "5px",
              height: "98vh",
              margin: "10px 10px",
              overflowY: "auto", // Enables vertical scrolling
              scrollbarWidth: "none", // Hides scrollbar in Firefox
              "-ms-overflow-style": "none", // Hides scrollbar in IE & Edge
              "&::-webkit-scrollbar": {
                display: "none", // Hides scrollbar in Chrome, Safari, Opera
              },
              "-webkit-overflow-scrolling": "touch", // Smooth scrolling on mobile
            },
          }}
        >
          <Box
            sx={{
              width: 620,
              display: "flex",
              flexDirection: "column",
            }}
            role="presentation"
          >
            <div>
              {state?.user?.id === state?.chat_details?.user_details?.id ? (
                <DrawerAnnounceDetail
                  classes={classes}
                  ann_id={Number(state?.chat_details?.id)}
                  onClose={() => {
                    handleGetShipmentRates(state?.selected_item);
                    setState({ drawerOpen: false });
                  }}
                />
              ) : (
                <DrawerJobDetail
                  classes={classes}
                  ann_id={Number(state?.chat_details?.id)}
                  onClose={() => {
                    handleGetShipmentRates(state?.selected_item);
                    setState({ drawerOpen: false });
                  }}
                />
              )}
            </div>
          </Box>
        </Drawer>
      </div>

      <div>
        <div className="mobile-screen">
          <MobileResponsive />
        </div>
      </div>
    </>
  );
}

export default SenderInbox;
